import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Track from '@project/shared/utils/tracking/js/tracking';

import 'select2'; // TODO: DO NOT => globally assign select2 fn to $ element

const classes = {
	downloadButton: 'js-m-download-item__button-download',
	languageSelect: 'js-m-download-item__language-selector',
	selected: 'state-m-download-item--selected',
};

@createModule('DownloadItem')
/**
 * download-item module implementation.
 *
 * @author Nele Rabus <nele.rabus@namics.com>
 */
export class DownloadItem extends TerrificSpec {
	async start(resolve: Function) {
		const $select = this._getLanguageSelect() as any;

		$select.select2({
			minimumResultsForSearch: -1,
			width: 'auto',
		});

		$select.on('change', () => this.updateDownloadButton());

		/**
		 * update url on init
		 */
		this.updateDownloadButton();

		this.RegisteredUpdate();

		resolve();
	}
	stop() {}
	/**
	 * returns jQuery ode Element
	 */
	_getDownloadButton() {
		return $(this._ctx).find(`.${classes.downloadButton}`);
	}
	/**
	 * returns DOM Element
	 */
	_getLanguageSelect() {
		return $(this._ctx).find(`.${classes.languageSelect}`);
	}

	/**
	 * Get input select value
	 */
	getLanguageSelectValue(): string {
		return this._getLanguageSelect().val() as string;
	}

	/**
	 * Setter for download button url
	 */
	setDownloadURL(href: string) {
		this._getDownloadButton().attr('href', href);
	}

	/**
	 * update download button
	 */
	updateDownloadButton() {
		this.setDownloadURL(this.getLanguageSelectValue());
	}

	RegisteredUpdate() {
		if (Track.isKnownMarketoLead()) {
			$(this._ctx).removeClass('m-download-item--locked');
		}
		if(Track.isKnownCdcLead()) {
			$(this._ctx).removeClass('m-download-item--locked');
		}
	}
}
